// Public tools. Add an entry here and it appears in the header Tools menu and
// the footer. Keep names short; `note` is the small label beside the name.
export const TOOLS = [
  { name: "Page audit", note: "Free", href: "/tools/seo-check", description: "Check one page’s SEO basics" },
];
